var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-icon",
    transform: "translate(-135 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    transform: "translate(135 194)",
    fill: "none",
    stroke: "#9edbd8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    transform: "translate(140 190)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    transform: "translate(139 203)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    transform: "translate(139 208)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    transform: "translate(147 190)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    transform: "translate(143 203)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    transform: "translate(143 208)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    transform: "translate(153 190)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    transform: "translate(147 203)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    transform: "translate(147 208)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    transform: "translate(151 203)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    transform: "translate(151 208)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    transform: "translate(155 203)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    transform: "translate(155 208)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    transform: "translate(139 198)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    transform: "translate(143 198)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    transform: "translate(147 198)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    transform: "translate(151 198)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    transform: "translate(155 198)",
    fill: "#9cdbd9",
    stroke: "#9edbd8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.fb7ef97f3e0759feb1f5e67ed047c9e4.svg";
export { ForwardRef as ReactComponent };